export default __webpack_public_path__ + "static/logo-3f69554b98eaec6ef4c78f712296523c.svg";